import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsService } from './services/analytics.service';
import { HeaderComponent } from './landing-page-v2/components/header/header.component';
import { HeroComponent } from './landing-page-v2/components/hero/hero.component';
import { HowItWorksComponent } from './landing-page-v2/components/how-it-works/how-it-works.component';
import { BenefitsComponent } from './landing-page-v2/components/benefits/benefits.component';
import { IndustryComponent } from './landing-page-v2/components/industry/industry.component';
import { AssistantComponent } from './landing-page-v2/components/assistant/assistant.component';
import { AppCtaComponent } from './landing-page-v2/components/app-cta/app-cta.component';
import { FooterComponent } from './landing-page-v2/components/footer/footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    HeroComponent,
    HowItWorksComponent,
    BenefitsComponent,
    IndustryComponent,
    AssistantComponent,
    AppCtaComponent,
    FooterComponent,
  ],
})
// RouterOutlet
export class AppComponent {
  constructor(private analytics: AnalyticsService) {}

  title = 'connectnow-web';
}
